export default "__VITE_ASSET__92aaa19d__"